export enum ERoleMode {
  READ_ONLY = 'READ_ONLY',
  HIDDEN = 'HIDDEN',
  DISABLED = 'DISABLED',
  INVISIBLE = 'INVISIBLE',
}

export enum ERoles {
  MASTER = 'MASTER',
}

export enum ERoleActions {
  VIEW_LOG = 'VIEW_LOG',
  VIEW_ADMIN = 'VIEW_ADMIN',
  VIEW_ADMIN_BOOKLETS = 'VIEW_ADMIN_BOOKLETS',
  VIEW_ADMIN_DASHBOARD = 'VIEW_ADMIN_DASHBOARD',
  VIEW_ADMIN_ACCOUNTING = 'VIEW_ADMIN_ACCOUNTING',
  VIEW_ADMIN_PARTNERS = 'VIEW_ADMIN_PARTNERS',
  CAN_CREATE_ADMIN_BOOKLETS = 'CAN_CREATE_ADMIN_BOOKLETS',
  CAN_DELETE_ADMIN_BOOKLETS = 'CAN_DELETE_ADMIN_BOOKLETS',
  CAN_FILTER_ADMIN_BOOKLETS_BY_GROUP_AND_AGENCY = 'CAN_FILTER_ADMIN_BOOKLETS_BY_GROUP_AND_AGENCY',
  CAN_EDIT_ADMIN_FILE_SETTINGS = 'CAN_EDIT_ADMIN_FILE_SETTINGS',
  CAN_VIEW_STRAPI_LINK = 'CAN_VIEW_STRAPI_LINK',
  CAN_VIEW_CASADOC_CALENDAR = 'CAN_VIEW_CASADOC_CALENDAR',
  CAN_VIEW_SURVEYOR_ASSIGNMENTS = 'CAN_VIEW_SURVEYOR_ASSIGNMENTS',
  VIEW_ADMIN_NEWSLETTER = 'VIEW_ADMIN_NEWSLETTER',
}
